export type TodoActionDashboardApiResponse = {
  code:number;
  message:string;
  data:{
    max_treatable_page:number;
    message :string;
    treatables:Treatables[]|[];
    max_todo_page:number;
    todos:Todos[]|[];
    max_not_treated_page:number;
    not_treated:NotTreated[]|[];
    max_sp_treatments_page:number;
    sp_treatments:SpTreatments[]|[];
  }
};

export type SpTreatments = {
  patient_name: string,
  patient_id: number,
  bi_case_id: number,
  provider: string,
  pharmacy_sp_status:string,
  pharmacy_sp_status_color: 1|2|3|4|5,
  provide_treatment_status: ["Treated"]|["Not Treated"]|["Treated","Not Treated"],
  sp_transferred_to: string| null,
  date_transferred: string |  null,
  status_update: ["text-color-yellow" ] | [ null],
  date_shipped: string | null,
  carrier:  string | null,
  tracking_number:string | null
};

export type NotTreated  = {
  patient_name:string,
  patient_id:number,
  bi_case_id:number,
  reverification:string,
  bi_submitted:string,
  bi_completed:string,
  payer:string,
  physician:string,
  medical_coverage_status:string,
  medical_provide_treatment_status:["Treated"]|["Not Treated"]|["Treated","Not Treated"],
  pharmacy_coverage_status:string,
  pharmacy_provide_treatment_status:"Not Treated"|null
};

export type  Todos = {
  patient_name:string,
  patient_id:number,
  bi_case_id:number,
  reverification:string,
  bi_completed:string,
  payer:string,
  physician:string,
  medical_coverage_status:string,
  medical_next_steps:string,
  pharmacy_coverage_status:string,
  pharmacy_next_steps:["Treated"]|["Not Treated"]|["Treated","Not Treated"]
};

export type Treatables = {
  patient_name  : string,
  patient_id: number,
  bi_case_id: number,
  reverification: string | null,
  bi_completed: string,
  payer: string,
  physician: string,
  medical_coverage_status: string,
  medical_provide_treatment_status: ["Treated"]|["Not Treated"]|["Treated","Not Treated"],
  pharmacy_coverage_status: string,
  pharmacy_provide_treatment_status: ["Treated"]|["Not Treated"]|["Treated","Not Treated"]
};

export type TodoActionDashboardErrorResponse = {
  code: number;
  error: string;
};






export type PatientFilterState = {
  // start_date: string;
  // end_date: string;
  case_id: string;
  global_patient_id: string;
  global_doctor_id: string;
  practice_id: string;
  ref_user:string;
  search_str : string;
  global_patient_external_id: string;
  role:string;
  id:string;
  treatable_page: number;
  todo_page: number;
  sp_treatment_page: number;
  not_treated_page: number;
};

export type PatientManufacturerFilterStart = PatientFilterState & {
  start_date: string;
  end_date: string;
}

export enum PatientFilterStateActions {
  SET_QUERY_PARAMS = 'setQueryParams',
  SET_REF_USER = 'setRefUser',

  CHANGE_TREATABLE_PAGE = 'changeTreatablePage',
  CHANGE_TODO_PAGE = 'changeTodoPage',
  CHANGE_SP_TREATMENT_PAGE = 'changeSPTreatmentPage',
  CHANGE_NOT_TREATED_PAGE = 'changeNotTreatedPage',
  CHANGE_USER_ROLE_AND_ID = "changeUserRoleAndId",
  RESET_FILTERS = "resetFilters"
};

export type ActionStatisticsDashboardActionType =
  {
    type: PatientFilterStateActions.SET_QUERY_PARAMS;
    payload: Omit<Omit<Omit<Omit<PatientFilterState, "treatable_page">, "todo_page">, "sp_treatment_page">, "not_treated_page">;
  } | {
    type: PatientFilterStateActions.SET_REF_USER,
    payload: string;
  } | {
    type: PatientFilterStateActions.CHANGE_TREATABLE_PAGE;
    payload: number;
  } | {
    type: PatientFilterStateActions.CHANGE_TODO_PAGE;
    payload: number;
  } | {
    type: PatientFilterStateActions.CHANGE_SP_TREATMENT_PAGE;
    payload: number;
  } | {
    type: PatientFilterStateActions.CHANGE_NOT_TREATED_PAGE;
    payload: number;
  }| {
    type: PatientFilterStateActions.CHANGE_USER_ROLE_AND_ID;
    payload: { role: string; id: string; ref_user: string; }
  } | {
    type: PatientFilterStateActions.RESET_FILTERS;
    payload: Partial<PatientFilterState>;
  };
